import { APP_FEATURES } from '../constants';
import { LTL_FEATURE_FLAG } from '../env';

/**
 * Determines if a feature is flagged off our not in the application
 * @param {string} feature - Feature that we are looking for a flag for
 * @return {boolean}
 */
const useFeatureFlag = (feature) => {
  const featureEnabled = (f) => (
    (f === 'true' || f === '"true"')
  );

  switch (feature) {
    case APP_FEATURES.LTL:
      return featureEnabled(LTL_FEATURE_FLAG);
    default:
      return false; // Unknown feature
  }
};

export default useFeatureFlag;
